import React from 'react'
import CoverController from '../../common/CoverController'
import PhotoCover from '../../Theme1/Cover/PhotoCover'
import Nophotocover from './Nophotocover'

const Cover = ({details,photoMode}) => {
  return (
    <CoverController 
   details={details}
  photoMode={photoMode}
      PhotoComponent={PhotoCover}
      NoPhotoComponent={Nophotocover}
  />
  )
}

export default Cover